import Modal from './Modal';
import { useTranslation } from '../../i18n/useTranslation';

const ConfirmationModal = ({
  visible = false,
  title,
  message = '',
  onOk = null,
  onCancel = null,
  okLabel,
  cancelLabel = null,
  danger = false
}) => {
  const { t } = useTranslation('common');

  const resolvedTitle = title || t('confirmation');
  const resolvedOkLabel = okLabel || t('ok');

  return (
    <Modal
      isOpen={visible}
      onClose={() => onCancel?.()}
      closeOnBackdrop={!!onCancel}
      panelClassName="bg-white rounded-lg shadow-lg w-full max-w-sm p-6"
    >
      <h3 className="text-lg font-semibold mb-4">{resolvedTitle}</h3>
      <p className="text-sm text-gray-700 mb-6" style={{ whiteSpace: 'pre-line' }}>{message}</p>
      <div className="flex justify-end gap-3">
        {cancelLabel && (
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            {cancelLabel}
          </button>
        )}
        <button
          onClick={onOk}
          className={`px-4 py-2 text-white rounded-lg transition-colors ${
            danger
              ? 'bg-red-600 hover:bg-red-700'
              : 'bg-[#024B99] hover:bg-[#023a7a]'
          }`}
        >
          {resolvedOkLabel}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
